import Button from '~/client/shared/Button';
import Translate from '~/client/shared/i18n/Translate';
import usePlayGame from '../../../hooks/usePlayGame';
import useDepositToPlay from '../hooks/useDepositToPlay';

const DepositToPlayBtnVariant = () => {
  const { loadingSession } = usePlayGame();
  const { handleDepositToPlay } = useDepositToPlay();

  return (
    <Button
      onClick={handleDepositToPlay}
      disabled={loadingSession}
      animation={loadingSession ? 'progress' : undefined}
    >
      <Translate id="game.deposit_to_play" />
    </Button>
  );
};

export default DepositToPlayBtnVariant;
